import { useContext } from 'react';

import { AppContext, AppContextType } from '@Stores';

const useAppContext = (): AppContextType => {
  return useContext(AppContext) as AppContextType;
};
export default useAppContext;
